<template>
  <el-dialog :visible.sync="dialogVisible" title="类目及包装模板详情" width="750px" :close-on-click-modal="false" append-to-body
    v-loading="loading">
    <el-form :model="form" label-width="90px" label-position="right">
      <el-form-item label="类目:">
        {{ `${form.twoCategoryName || '-'} >> ${form.threeCategoryName || '-'}` }}
      </el-form-item>
      <el-form-item label="包装模板:">
        <div class="pack-selection" v-if="form.categoryPackageNames && form.categoryPackageNames.length > 0">
          <div class="pack-item" v-for="item in form.categoryPackageNames" :key="item.packageTemplateId">
            <div class="pack-content">
              <el-checkbox v-model="form.categoryPackageChecked" :label="item.packageTemplateId">
                {{ item.packageTemplateName }}
              </el-checkbox>
              <el-image :src="item.packageTemplateImg" style="width: 50px;height: 50px;" fit="contain"
                :preview-src-list="[item.packageTemplateImg]" />
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="addBindPackage()">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      categoryId: "",
      dialogVisible: false,
      loading: false,
      form: {},
    }
  },
  created() {

  },
  watch: {
  },
  methods: {
    open(id) {
      this.categoryId = id
      this.getInfo()
    },
    async getInfo() {
      this.loading = true
      const res = await this.$request.get("/cms/category_packaget/get_category_package_list_by_id?CategoryId=" + this.categoryId)
      if (res.data.code == 200) {
        this.form = res.data.data
        this.dialogVisible = true
      }
      this.loading = false
    },
    async addBindPackage() {
      const res = await this.$request.post("/cms/category_packaget/add_category_package", {
        categoryId: this.categoryId,
        packageId: this.form.categoryPackageChecked
      })
      if (res.data.code === 200) {
        this.$message.success("操作成功")
        this.dialogVisible = false
        this.$emit("getList")
      }
    },
  }
}
</script>

<style scoped>
.pack-selection {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 50%;
}

.pack-item {
  margin-bottom: 10px;
}

.pack-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pack-content .el-image {
  cursor: pointer;
  flex-shrink: 0;
}

.pack-content .el-image:hover {
  opacity: 0.8;
}
</style>